export default __webpack_public_path__ + "static/media/computer.ef34c21e.svg";